module.exports = __webpack_public_path__ + "static/media/DeleteOCR.c892a487.svg";